import { render } from "./rocList.vue?vue&type=template&id=8543a35a"
import script from "./rocList.vue?vue&type=script&lang=js"
export * from "./rocList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__